import { httpConfig } from "../httpConfig";
import { RequestFetch } from "./requestFetch";

export const CheckWorkAdvisor = async (idAdvisor, idWork, tokenUser) => {
  try {
    return await fetch(
      `${httpConfig()}/work`,
      RequestFetch("POST", { id: idAdvisor }, tokenUser)
    ).then((res) =>
      res.json().then((data) => {
        if (data) {
          // console.log("CheckWorkAdvisor Work !!!=>", data);
          let resultFind = data.find(
            (item) => item.workID.toString().trim() === idWork.toString().trim()
          );
          // console.log("CheckWorkAdvisor resultFind ===>", resultFind);
          if (resultFind) {
            return true;
          } else if (!resultFind) {
            return false;
          }
        }
      })
    );
  } catch (error) {
    console.error("fail to CheckWorkAdvisor", error);
  }
};
